import React from 'react';
import '../../../styles/style.css';

const RoutePoints = ({ points = [] }) => {
  if (points.length === 0) return null;

  return (
    <div className="routePointsWrapper flex-column">
      {points.map((point, index) => (
        <div key={point.id} className="routePointCard">

          {/* Заголовок + индекс */}
          <div className="routePointHeader">
            <div className="routePointIndex">
              {index + 1}
            </div>
            <h3 className="routePointTitle">
              {point.name}
            </h3>
          </div>

          {/* Фото — теперь прямо в routePointCard, вне routePointContent */}
          {point.photos && point.photos.length === 2 ? (
            <div className="routePointPhotosTwo">
              <img
                src={point.photos[0].link || point.photos[0].url}
                alt={point.name || "Фото точки 1"}
                className="routePointImageBig"
              />
              <img
                src={point.photos[1].link || point.photos[1].url}
                alt={point.name || "Фото точки 2"}
                className="routePointImageSmall"
              />
            </div>
          ) : point.photos && point.photos.length === 1 ? (
            <img
              src={point.photos[0].link || point.photos[0].url}
              alt={point.name || "Фото точки"}
              className="routePointImage"
            />
          ) : (
            <div className="routePointImagePlaceholder">
              Нет фото
            </div>
          )}

          {/* Текст — тоже прямо в routePointCard */}
          <div className="routePointContent">
            <div className="routePointDescription">
              {point.description && (
                <div>
                  {point.description.split('\\n').map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RoutePoints;